// Default the Size option to Medium on product pages, so the advertised/selected price
// reflects the standard size (not the cheaper X-Small). Runs once on load only when the
// customer has not explicitly chosen a variant. Uses the theme's own variant picker so the
// highlighted size, price, and add-to-cart variant all sync together.
(function () {
  function run() {
    if (!/\/products\//.test(window.location.pathname)) return;
    if (new URLSearchParams(window.location.search).has('variant')) return; // respect explicit choice
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var fieldsets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (!legend || !/size/i.test(legend.textContent || '')) continue;
      var radios = fieldsets[i].querySelectorAll('input[type="radio"]');
      var medium = null, current = null;
      for (var j = 0; j < radios.length; j++) {
        var v = (radios[j].value || '').trim().toLowerCase();
        if (radios[j].checked) current = radios[j];
        if ((v === 'medium' || v === 'm') && radios[j].dataset.optionAvailable !== 'false') medium = radios[j];
      }
      if (medium && medium !== current) {
        medium.click(); // triggers the picker's change handler -> syncs everything to Medium
      }
      return; // only the Size fieldset
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
